import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { DetailOrderDialogComponent } from '../dialogs/detail-order-dialog/detail-order-dialog.component';
import { NotificationAuthorizeOrderComponent } from '../dialogs/notification-authorize-order/notification-authorize-order.component';
import {
  GeneralMessage,
  NotificationAuthorizeOrder,
} from '../model/device/message.model';
import { ContainerSelectorEstructor } from '../model/http/container-selector.model';
import { CallPlace } from '../model/http/myActivity.model';
import {
  BackOrderActions,
  BackOrderActionsButtons,
  IPendingOrders,
} from '../model/http/pendingOrders';
import {
  CloseDetailOrderData,
  OpenDetailOrderData,
  SignatureData,
} from '../model/local/general.model';
import { PaymentInformation } from '../model/local/payment.model';
import { ObservableService } from './observable.service';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    private dialog: MatDialog,
    private observableService: ObservableService
  ) { }

  displayDialog<T>(
    component: ComponentType<T> | TemplateRef<T>,
    config: MatDialogConfig,
    autoFocus: boolean = false
  ): MatDialogRef<T> {
    config.autoFocus = autoFocus;
    config.maxHeight = '90vh';
    return this.dialog.open(component, config);
  }
  openContainerSelector<T>(
    component: ComponentType<T> | TemplateRef<T>,
    estructor: ContainerSelectorEstructor
  ): void {
    this.dialog
      .open(component, { data: estructor, autoFocus: false })
      .afterClosed()
      .subscribe((data) => {
        if (data) {
          this.observableService.setActiveContainerSelector(data.data);
        }
      });
  }


  openNotificationGeneric<T>(
    component: ComponentType<T> | TemplateRef<T>,
    notificationMessage: GeneralMessage
  ): void {
    this.dialog
      .open(component, {
        data: notificationMessage, autoFocus: false
      })
      .afterClosed()
      .subscribe((result: GeneralMessage) => {
        if (result) {
          this.observableService.setResultNotificationGeneric(result);
        }
      });
  }
  openSuccessSignature<T>(
    component: ComponentType<T> | TemplateRef<T>,
    signatureResult: SignatureData
  ): void {
    this.dialog
      .open(component, {
        data: signatureResult,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.observableService.setSignatureResult(result);
        }
      });
  }

  openDetailOrder(data: OpenDetailOrderData): MatDialogRef<DetailOrderDialogComponent> {
    return this.dialog.open(DetailOrderDialogComponent, { data });
  }
}
